import React, { useState } from "react";
import clsx from "clsx";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import {
  Drawer,
  Popover,
  AppBar,
  // Button,
  Toolbar,
  List,
  CssBaseline,
  // Divider,
  ListItem,
  ListItemText,
  ListItemIcon,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import MenuIcon from "@material-ui/icons/Menu";
import { useSelector, useDispatch } from "react-redux";
import { NavLink, Route, Switch, useHistory, Link } from "react-router-dom";
import { sendLogoutRequest } from "../store/actions/auth.actions";
import { getUserDetails } from "../store/actions/user.actions";
import PageLoader from "../components/page-loader.component";
import { isUserAdmin } from "../utils/useRole";

const drawerWidth = 200;

function activeRoute(routeName) {
  return window.location.href.indexOf(routeName) > -1 ? true : false;
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  logout: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginRight: "2rem"
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: "#fff",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    backgroundColor: "#fff",
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    outline: "none",
  },
  drawerOpen: {
    width: drawerWidth,
    padding: "2.5rem 1rem 2.5rem 1rem",
    backgroundColor: "#fff",
    outline: "none",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    outline: "none",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
    backgroundColor: "#fff",
    color: "#ffb547",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    width: `calc(100vw - ${drawerWidth}px)`,
    height: "100vh",
    backgroundColor: "#f2f2f2",
  },
  item: {
    textDecoration: "none",
    fontSize: "0.7rem",
    color: "#333",
  },
  drawerButton: {
    borderRadius: "0.4rem",
    backgroundColor: "#f4b547",
  },
  activeItem: {
    fontSize: "0.8rem",
    color: "#fff",
    background: "#f4b547",
  },
  paper: {
    whiteSpace: "nowrap",
    outline: "none",
    borderBottom: "1px solid #ddd",
  },
}));

const DashAppBar = ({ open, handleDrawerOpen, history }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const user = useSelector(({ auth }) => auth.user);
  const [anchorEl, setAnchorEl] = useState(null);

  const pop = Boolean(anchorEl);

  return (
    <AppBar
      position="fixed"
      className={clsx(classes.appBar, {
        [classes.appBarShift]: open,
      })}
      // color="#fff"
      elevation={0}
    >
      <Toolbar className={classes.toolbar}>
        {/* <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerOpen}
          edge="start"
          className={clsx(classes.menuButton, {
            [classes.hide]: open,
          })}
        >
          <MenuIcon style={{ color: "#ffb547" }} />
        </IconButton> */}

        <div className={classes.logout}>
          <img
            src={
              user?.pixUrl ??
              "https://res.cloudinary.com/tractrac-global/image/upload/v1617202330/african-2742668_640_zopthg.webp"
            }
            alt="user passport"
            style={{
              borderRadius: "100%",
              width: "20px",
              height: "20px",
              marginRight: "10px",
            }}
          />
          <Typography style={{fontSize: 10}} variant="caption">Hello, {user?.fname}</Typography>
          <div style={{display: 'flex', alignItems: 'center'}} role="button" onClick={(ev) => setAnchorEl(ev.currentTarget)}>
            {pop ? (
              <ExpandLessIcon fontSize="small" color="#323232" />

            ) : (
              
              <ExpandMoreIcon fontSize="small" color="#ffb547" />
            )}
          </div>
          <Popover
            id={pop ? "popover" : undefined}
            open={pop}
            anchorEl={anchorEl}
            onClose={() => setAnchorEl(null)}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          >
            <div style={{ padding: "0.5rem" }}>
              <List>
                {/* <Link to="/settings" className={classes.item}>
                  <ListItem button>
                    <ListItemText
                      primary="Settings"
                      style={{ color: "#333" }}
                    />
                  </ListItem>
                </Link> */}
                {isUserAdmin(user.userRole) ? 
                
                window.location.pathname === '/admin/dashboard' ? 
                (
                  <Link to="/user/dashboard" className={classes.item}>
                    <ListItem button>
                      <ListItemText
                        primary="User Panel"
                        style={{ color: "#333" }}
                      />
                    </ListItem>
                  </Link>
                ):
                (
                  <Link to="/admin/dashboard" className={classes.item}>
                    <ListItem button>
                      <ListItemText
                        primary="Admin Panel"
                        style={{ color: "#333" }}
                      />
                    </ListItem>
                  </Link>
                ) : null}
                <p
                  role="button"
                  onClick={() => {
                    dispatch(sendLogoutRequest());
                    history.push("/");
                  }}
                  className={classes.item}
                >
                  <ListItem button>
                    <ListItemText primary="Logout" style={{ color: "#333" }} />
                  </ListItem>
                </p>
              </List>
            </div>
          </Popover>
        </div>
      </Toolbar>
    </AppBar>
  );
};

const DashDrawer = ({ open, handleDrawerClose, theme, routes }) => {
  const classes = useStyles();
  return (
    <Drawer
      variant="permanent"
      className={clsx(classes.drawer, {
        [classes.drawerOpen]: open,
        [classes.drawerClose]: !open,
      })}
      classes={{
        paper: classes.drawerOpen,
        // clsx({
        //   [classes.drawerOpen]: open,
        //   [classes.drawerClose]: !open,
        // }),
      }}
    >
      {/* <div className={classes.toolbar}>
        <IconButton onClick={handleDrawerClose}>
          {theme.direction === "rtl" ? (
            <MenuIcon color="#ffb547" />
          ) : (
            <MenuIcon style={{ color: "#ffb547" }} />
          )}
        </IconButton>
      </div>
      <Divider /> */}
      <List>
        {routes.map((route, index) => {
          return (
            <NavLink
              to={route.path}
              className={classes.item}
              activeClassName="active"
              key={`${route.name}_${index}`}
            >
              <ListItem
                className={clsx({
                  [classes.drawerButton]: activeRoute(`${route.path}`),
                })}
              >
                <ListItemIcon
                  style={{
                    marginRight: "-30px",
                  }}
                >
                  <FontAwesomeIcon
                    icon={route.icon}
                    size="lg"
                    color={activeRoute(`${route.path}`) ? "white" : "#333"}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={route.name}
                  style={{
                    textDecoration: "none",
                    color: activeRoute(`${route.path}`) ? "white" : "#333",
                  }}
                />
              </ListItem>
            </NavLink>
          );
        })}
      </List>
    </Drawer>
  );
};

export default function DashboardLayout({ children }) {
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();
  const theme = useTheme();
  const [open, setOpen] = React.useState(true);
  const [loading, setLoading] = useState(true);
  const userRole = useSelector(({ auth }) => auth.userRole);

  React.useEffect(() => {
    dispatch(
      getUserDetails((data) => {
        if (data === "failed") {
          setLoading(false);
           dispatch(sendLogoutRequest());
           return
        }
        setLoading(false);
      })
    );
  }, [dispatch]);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return loading ? (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <PageLoader />
    </div>
  ) : (
    <div className={classes.root}>
      <CssBaseline />
      <DashAppBar
        open={open}
        handleDrawerOpen={handleDrawerOpen}
        history={history}
      />
      <DashDrawer
        open={open}
        handleDrawerClose={handleDrawerClose}
        theme={theme}
        userRole={userRole}
        routes={children}
      />
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <Switch>
          {children.map((route) => {
            return (
              <Route
                path={route?.path}
                component={route?.component}
                render={route?.render}
                key={`${route?.name}-${userRole}`}
              />
            );
          })}
        </Switch>
      </main>
    </div>
  );
}
